import React from 'react'
import { FormFieldInterface } from 'src/shared/types/entities/form-interface'
import { BasePublisherCountryField } from '../../base-publisher-field/base-publisher-country-field'
import { useFormField } from '../hooks/use-form-field'

interface FormCountryFieldSubentityProps {
  fieldSubentity: FormFieldInterface
}

export const FormCountryFieldSubentity = ({
  fieldSubentity,
}: FormCountryFieldSubentityProps) => {
  const { value, onChange, errors } = useFormField({ fieldSubentity })
  return (
    <BasePublisherCountryField
      entity={fieldSubentity}
      value={value}
      onChange={onChange}
      errors={errors}
    />
  )
}
